import { render, staticRenderFns } from "./sertificates-reissue.vue?vue&type=template&id=6722b682&scoped=true"
import script from "./sertificates-reissue.vue?vue&type=script&lang=ts"
export * from "./sertificates-reissue.vue?vue&type=script&lang=ts"
import style0 from "./sertificates-reissue.vue?vue&type=style&index=0&id=6722b682&prod&lang=css&scoped=true"
import style1 from "./sertificates-reissue.vue?vue&type=style&index=1&id=6722b682&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722b682",
  null
  
)

export default component.exports